import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, ModuleConfigService, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class AppCanBoNhanVien_DangKyXetNghiemService extends BaseService {
    useWorkflow = true;
    entityName = 'AppCanBoNhanVien_DangKyXetNghiem';
    serviceCode = 'SKTQ';

    constructor(http: HttpClient, injector: Injector,
        private _moduleConfigService: ModuleConfigService) {
        super(http, injector, `${_moduleConfigService.getConfig().environment.apiDomain.userOrgEndpoint}/AppCanBoNhanVien_DangKyXetNghiem`);
        this.endPoint = _moduleConfigService.getConfig().environment.apiDomain.userOrgEndpoint;
    }

    submit(data: any): Promise<ResponseResult> {
        const url = `${this.serviceUri}/submit`;
        return this.defaultPost(url, data);
    }

    getAllOptionalService(): Promise<ResponseResult> {
        const url = `${this.serviceUri}/optional-services`;
        return this.defaultGet(url);
    }
}
